import React from 'react';
import {Card, CardContent, Grid, Icon, IconButton, Tooltip, withStyles} from "@material-ui/core";
import {Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from "../../components/Toolbar/Toolbar";

class OfflineGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            protocols: this.setProtocols(),
        };
    }

    setProtocols = () => {
        let protocols = [];
        const localStorageKeys = Object.keys(localStorage)
        localStorageKeys.map(item => {
            if (item.startsWith('protocol_') ) {
                console.log(item)
                const protocolDeserialized = JSON.parse(localStorage.getItem(item));
                protocolDeserialized.item_key = item;
                protocols.push(protocolDeserialized);
            }
        });

        return protocols;
    }

    syncProtocol = (key) => {
        let storedItem = localStorage.getItem(key);
        let storedItemDeserialized = JSON.parse(storedItem);
        let protocols = this.state.protocols.filter(val => val.item_key != key)

        axios.post('/protocols', storedItemDeserialized)
            .then(() => {
                swal({
                    icon: "success",
                    title: i18n.get('offline.synch_success'),
                    timer: 4000,
                });

                localStorage.removeItem(key);
                this.setState({protocols})
                // window.location.reload()

            }).catch(() => {
                swal({
                    icon: "error",
                    title: i18n.get('offline.synch_error'),
                })
            })
    }

    deleteProtocol = (key) => {
        let protocols = this.state.protocols.filter(val => val.item_key != key)
        localStorage.removeItem(key);
        this.setState({protocols})
    }

    render() {
        const {classes} = this.props;
        const {protocols} = this.state;

        return (
            <Layout>
                <Toolbar
                    disableGutters
                    title={i18n.get('offline.all_protocols')}
                    subtitle={`${protocols.length} ${i18n.get('offline.number_of_offline')}`}
                    items={[
                        {
                            icon: 'sync',
                            text: i18n.get('offline.sync_all'),
                        }
                    ]}
                />
                <Card className={classes.paperProperties}>
                    <CardContent>
                        <Grid container spacing={8}>
                            <Grid item xs={12}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell scope="col">{i18n.get('offline.customer')}</TableCell>
                                            <TableCell scope="col">{i18n.get('offline.appointment')}</TableCell>
                                            <TableCell scope="col">{i18n.get('offline.protocol')}</TableCell>
                                            <TableCell scope="col">&nbsp;</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {protocols.map(protocol => (
                                            <TableRow>
                                                <TableCell>{protocol.customer_name}</TableCell>
                                                <TableCell>{protocol.appointment_name}</TableCell>
                                                <TableCell>{protocol.structure_name}</TableCell>
                                                <TableCell>
                                                    <Tooltip placement="bottom-end"
                                                             title={i18n.get('offline.sync')}
                                                             classes={{tooltip: classes.popper}}>
                                                        <IconButton
                                                            component="a"
                                                            onClick={() => this.syncProtocol(protocol.item_key)}
                                                        >
                                                            <Icon>sync</Icon>
                                                        </IconButton>
                                                    </Tooltip>

                                                    <Tooltip placement="bottom-end"
                                                             title={i18n.get('offline.delete')}
                                                             classes={{tooltip: classes.popper}}>
                                                        <IconButton
                                                            component="a"
                                                            onClick={() => this.deleteProtocol(protocol.item_key)}
                                                        >
                                                            <Icon style={{ color: 'red' }}>delete</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Layout>
        )
    }
}

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(OfflineGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/protocols/Offline.jsx